import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  constructor() { }

  getCurrentCoordinates(throwError: boolean = true): Observable<GeolocationCoordinates> {
    const fakeCoords: GeolocationCoordinates  = {
      accuracy: 0,
      altitude: null,
      altitudeAccuracy: null,
      heading: null,
      latitude: 0,
      longitude: 0,
      speed: null
    };

    return new Observable<GeolocationCoordinates>((observer) => {
      if (!navigator.geolocation) {
        if (throwError) {
          observer.error(new Error('Geolokalizacja nie jest wspierana przez tę przeglądarkę.'));
        } else {
          observer.next(fakeCoords);
          observer.complete();
        }
        return;
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          observer.next(position.coords);
          observer.complete();
        },
        error => {
          if(throwError) {
            observer.error(error);
          }
          else{
            observer.next(fakeCoords);
            observer.complete();
          }
        }
      )
    })
  }
}
